import { Injectable, inject } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { AuthorizeService } from 'src/api-authorization/authorize.service';

@Injectable({
	providedIn: 'root'
})
export class AdminGuard implements CanActivate {
	private authorize = inject(AuthorizeService);
	private router = inject(Router);

	canActivate(_next: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
		return this.authorize.authState$.pipe(
			filter(s => s !== 'unknown'),
			take(1),
			map(() => {
				if (this.authorize.isAdmin$()) {
					return true;
				}
				this.router.navigate(['error/unauthorized']);
				return false;
			})
		);
	}
}
